import { Injectable } from '@angular/core'
import { ICustomTableColumn, ICustomTableHeader } from '../modals/interface/custom-table.interface'
import { Subject } from 'rxjs'

@Injectable()
export class CustomTableService {
  public clicked$ = new Subject()
  public dataSource: any

  public getHeaders(data: ICustomTableHeader[]): ICustomTableHeader[] {
    return data.map((item) => {
      const newHeader = { ...item }
      if (item.title.includes('.')) {
        newHeader.translate = true
      }
      return newHeader
    })
  }

  public getColumns(data: ICustomTableColumn[], headers: ICustomTableHeader[]): ICustomTableColumn[] {
    return data.map((item, index) => {
      const keys = item.key.split('.')
      return {
        ...item,
        finalKey: item.key,
        finalKeys: keys,
        label: headers[index]
      }
    })
  }

  public getRows(data: any[], columns: ICustomTableColumn[]): any[] {
    const rows: any[] = []
    for (const itemData of data) {
      const value = {}
      for (const column of columns) {
        value[column.finalKey] = this.getValueFromObject(itemData, column.finalKeys, 0)
      }
      rows.push(value)
    }
    return rows
  }

  private getValueFromObject(data: any, keys: string[], keyIndex: number): any {
    const key = keys[keyIndex]
    if (keys.length - 1 > keyIndex) {
      const nextKeyIndex = keyIndex + 1
      const nextLevel = data[key]

      if (!nextLevel) {
        return null
      }
      return this.getValueFromObject(nextLevel, keys, nextKeyIndex)
    }

    const value = data[key]
    return value !== undefined && value !== null ? value : null
  }

  public clicked(control: any, row: any): void {
    this.clicked$.next({ control, row })
  }
}
